import styled from 'styled-components';
import {Typography} from '@/components/Typography';
import {palette} from '@/styles';
import Img from './error.svg';

export const ErrorBox = () => {
  return (
    <Root>
      <Typography variant="medium14" color={palette.gray600} align="center">
        일시적인 오류가 발생했습니다.
        <br />
        잠시 후 다시 시도해 주세요.
      </Typography>
      <img src={Img} alt="일시적인 오류가 발생했습니다" />
    </Root>
  );
};

const Root = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;
